module.exports = __webpack_public_path__ + "static/media/multiple-choice-letters.191cadc2.svg";